export type CircuitsListUrlState = {
  name: string;
  countries: string | null;
  durationDays: string | null;
  durationNights: string | null;
  page: number;
  sortField: string;
  sortOrder: 'asc' | 'desc';
};

export const buildCircuitsListSearch = (
  params: CircuitsListUrlState | null | undefined,
) => {
  if (!params) return '';
  const search = new URLSearchParams();
  if (params.name != null && params.name !== '') {
    search.set('name', params.name);
  }
  if (params.countries != null && params.countries !== '') {
    search.set('countries', params.countries);
  }
  if (params.durationDays != null && params.durationDays !== '') {
    search.set('durationDays', params.durationDays);
  }
  if (params.durationNights != null && params.durationNights !== '') {
    search.set('durationNights', params.durationNights);
  }
  if (params.page != null && params.page > 1) {
    search.set('page', String(params.page));
  }
  if (params.sortField != null && params.sortField !== '') {
    search.set('sortField', params.sortField);
    search.set('sortOrder', params.sortOrder);
  }
  const str = search.toString();
  return str ? `?${str}` : '';
};
